import {registerPlugin} from "@capacitor/core";
import {NfcCardInfo} from "../ebelediye/entities/NfcCardInfo";

export interface ThreeDSOptions {
  postUrl: string;
  postData: string; // URL-encoded string
}

export interface ThreeDSResult {
  status: 'success' | 'fail' | 'cancelled';
  referansNo?: string;
  message?: string;
}

export interface BaylanCardPlugin {
  hasNfc(): Promise<{ hasNfc: boolean }>;
  readCard(): Promise<NfcCardInfo>;
  loadCredit(options: { amount: number }): Promise<{ kod: string; aciklama: string }>;

  startThreeDS(options: ThreeDSOptions): Promise<ThreeDSResult>;
}

const BaylanCardPlugin = registerPlugin<BaylanCardPlugin>('BaylanCardPlugin');

export default BaylanCardPlugin;
